import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import AnalyticsWrapper from './AnalyticsWrapper';

import SubscribeToday from './pages/SubscribeToday';
import ReactivateToday from './pages/ReactivateToday';
import ReactivateMembership from './pages/ReactivateMembership';
import { UpgradeRoot } from './pages/UpgradeRedesign';
import TrialUpgradeThanks from './pages/TrialUpgradeThanks';
import UpgradeThanks from './pages/UpgradeThanks';
import ReactivateThanks from './pages/ReactivateThanks';
import TrialUpgrade from './pages/TrialUpgrade';
import EmailPreferences from './pages/EmailPreferences';
import MyAccountContainer from './pages/MyAccount';
import NotFoundError from './pages/NotFoundError';
import ProRatedUpgradePage from './pages/ProRatedUpgrade';
import LockInRate from './pages/LockInRate';
import { addPathPrefix } from './helpers';
import ContactUs from './pages/ContactUs';
import {
  CONTACT_US_PATH,
  LOCK_IN_RATE_PATH,
  PRORATE_UPGRADE,
  REACTIVATE_TODAY,
  REACTIVATE_MEMBERSHIP,
  REACTIVATE_THANKS,
  UPGRADE_CONFIRMATION,
  ACTIVATE_BOX_SUBSCRIPTION,
  UPGRADE_THANKS,
  TRIAL_UPGRADE_THANKS,
  EMAIL_PREFERENCES,
  MY_ACCOUNT,
  ACTIVATE_MEMBERSHIP,
  SUBSCRIBE_TODAY_THANKS,
} from './utils/routePaths';

export const AppRoutes = ({ flags }) => {
  if (!flags || Object.keys(flags).length === 0) {
    return null;
  }

  return (
    <Router>
      <AnalyticsWrapper>
        <Switch>
          {flags.newReactivate !== false && [
            <Route
              exact
              path={addPathPrefix(REACTIVATE_TODAY, flags)}
              component={ReactivateToday}
              key="1"
            />,
            <Route
              exact
              path={addPathPrefix(REACTIVATE_MEMBERSHIP, flags)}
              component={ReactivateMembership}
              key="2"
            />,
            <Route
              exact
              path={addPathPrefix(REACTIVATE_THANKS, flags)}
              component={ReactivateThanks}
              key="3"
            />,
          ]}
          {flags.newUpgrade !== false && [
            <Route
              exact
              path={addPathPrefix(UPGRADE_CONFIRMATION, flags)}
              component={UpgradeRoot}
              key="4"
            />,
            <Route
              exact
              path={addPathPrefix(ACTIVATE_MEMBERSHIP, flags)}
              component={TrialUpgrade}
              key="5"
            />,
            <Route
              exact
              path={addPathPrefix(UPGRADE_THANKS, flags)}
              component={UpgradeThanks}
              key="6"
            />,
            <Route
              exact
              path={addPathPrefix(PRORATE_UPGRADE, flags)}
              component={ProRatedUpgradePage}
              key="7"
            />,
          ]}
          <Route
            exact
            path={ACTIVATE_BOX_SUBSCRIPTION}
            component={SubscribeToday}
            key="8"
          />
          <Route
            exact
            path={addPathPrefix(TRIAL_UPGRADE_THANKS, flags)}
            component={TrialUpgradeThanks}
            key="9"
          />
          <Route
            exact
            path={addPathPrefix(EMAIL_PREFERENCES, flags)}
            component={EmailPreferences}
            key="10"
          />
          <Route
            exact
            path={SUBSCRIBE_TODAY_THANKS}
            component={ReactivateThanks}
            key="11"
          />
          <Route
            path={addPathPrefix(MY_ACCOUNT, flags)}
            component={MyAccountContainer}
          />
          <Route
            exact
            path={LOCK_IN_RATE_PATH}
            component={LockInRate}
            key="12"
          />
          <Route exact path={CONTACT_US_PATH} component={ContactUs} key="13" />
          <Route component={NotFoundError} key="14" />
        </Switch>
      </AnalyticsWrapper>
    </Router>
  );
};

export default withLDConsumer()(AppRoutes);
